export const SET_OBJECT = "SET_OBJECT";
export const SET_NUMBEROFPERSONS = "SET_NUMBEROFPERSONS";
export const TacModuleTypeEnum = {
    "DINING" : "dining",
    "SPA" : "spa",
    "ACTIVITY" : "activity"
}
